<div class="col formscreen">
  <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
  <form class="loginform" [formGroup]="setpwForm" (ngSubmit)="onSubmit()">
    <div class="col headline">
      <h1>Set new password</h1>
      <span
        >Set a new password for your account. After that you are directly logged
        in.</span
      >
    </div>
    <div class="col withlink tiny">
      <rr-input
        label="Enter your password"
        type="password"
        [verifyPassword]="true"
        [required]="true"
        formControlName="password"
      ></rr-input>
      <a href="/login">Log in again?</a>
    </div>
    <rr-btn type="Primary" (btnClick)="onSubmit()">Log in</rr-btn>
  </form>
</div>
<div class="rightsideimage"></div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
